<template>
    <div class="col-12 mx-auto">
        <div class="card">
            <div class="card-header bg-primary text-white">
                <page-title :title="$t('reportData.events.title')" :showTitle="false"></page-title>
                <div class="card-title h5 m-0">
                    {{ $t('reportData.events.title') }}
                </div>
            </div>

            <div class="card-header" v-if="showReportDataEventsSettings">
                <span v-if="showReportDataEventsSettings">
                    <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                       @click.stop="changeGridSettings('reportDataEventsGrid')"
                       data-toggle="tooltip"
                       :title="$t('buttons.settings.tooltipText')"></i>
                </span>

                <div v-if="showReportDataEventsSettings">
                    <GridUserSettings ref="reportDataEventsSettings"
                                      :visible="showReportDataEventsSettingsForm"
                                      :grid="$refs['reportDataEventsGrid']"
                                      :componentName="componentName">
                    </GridUserSettings>
                </div>
            </div>

            <div class="card-body">
                <div class="btn-toolbar justify-content-between mt-0 mb-2" role="toolbar">
                    <div class="form-inline col-6">

                    </div>

                    <div class="input-group">
                        <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size="gridOptions.pageable.size"
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>

                <kendo-grid ref="reportDataEventsGrid"
                            :data-source-ref="'datasource1'"
                            :navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="gridOptions.toolbar"
                            :dataBound="dataBound"
                            :excel="gridOptions.excel"
                            name="reportDataEventsGrid">


                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('actions')"
                                       :filterable="false"
                                       :sortable="false"
                                       v-if="showBtns && hasEventReadRights"
                                       :width="150"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'id'"
                                       :title="$t('reportData.events.eventId')"
                                       :width="100"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventName'"
                                       :title="$t('reportData.events.eventName')"
                                       :width="350"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventCode'"
                                       :title="$t('reportData.events.eventCode')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'shortDates'"
                                       :title="$t('reportData.events.shortDates')"
                                       :width="200"
                                       :sortable="false"
                                       :filterable="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventVenue'"
                                       :title="$t('reportData.events.eventVenue')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLocation'"
                                       :title="$t('reportData.events.eventLocation')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLocationDistrict'"
                                       :title="$t('reportData.events.eventLocationDistrict')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventMainActivity'"
                                       :title="$t('reportData.events.eventMainActivity')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventDirectorate'"
                                       :title="$t('reportData.events.eventDirectorate')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventActivityDirection'"
                                       :title="$t('reportData.events.eventActivityDirection')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventSort'"
                                       :title="$t('reportData.events.eventSort')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventFundingType'"
                                       :title="$t('reportData.events.eventFundingType')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventProjectName'"
                                       :title="$t('reportData.events.eventProjectName')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventForm'"
                                       :title="$t('reportData.events.eventForm')"
                                       :width="170">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'contactPersons'"
                                       :title="$t('reportData.events.contactPersons')"
                                       :width="500">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'coordinators'"
                                       :title="$t('reportData.events.coordinators')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventOrganizerName'"
                                       :title="$t('reportData.events.eventOrganizerName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('reportData.events.eventStartDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('reportData.events.eventStartDateHour')"
                                       :width="150"
                                       :format="customTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('reportData.events.eventEndDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('reportData.events.eventEndDateHour')"
                                       :width="150"
                                       :format="customTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLegalArea'"
                                       :title="$t('reportData.events.eventLegalArea')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'thematicArea'"
                                       :title="$t('reportData.events.thematicArea')"
                                       :width="500">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'lecturers'"
                                       :title="$t('reportData.events.lecturers')"
                                       :width="500">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participantsMaxNum'"
                                       :title="$t('reportData.events.participantsMaxNum')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventAudience'"
                                       :title="$t('reportData.events.eventAudience')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'hotelName'"
                                       :title="$t('reportData.events.hotelName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'hotelAddress'"
                                       :title="$t('reportData.events.hotelAddress')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'lastDayForBooking'"
                                       :title="$t('reportData.events.lastDayForBooking')"
                                       :width="200"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStayFrom'"
                                       :title="$t('reportData.events.eventStayFrom')"
                                       :width="200"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStayTo'"
                                       :title="$t('reportData.events.eventStayTo')"
                                       :width="200"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventDailyAllowanceFrom'"
                                       :title="$t('reportData.events.eventDailyAllowanceFrom')"
                                       :width="200"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventDailyAllowanceTo'"
                                       :title="$t('reportData.events.eventDailyAllowanceTo')"
                                       :width="200"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'noteStatus'"
                                       :title="$t('reportData.events.noteStatus')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventSubscriptionStartDate'"
                                       :title="$t('reportData.events.eventSubscriptionStartDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventSubscriptionEndDate'"
                                       :title="$t('reportData.events.eventSubscriptionEndDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'excludeFromReporting'"
                                       :title="$t('reportData.events.excludeFromReporting')"
                                       :width="200"
                                       :template="excludeCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStatus'"
                                       :title="$t('reportData.events.eventStatus')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdByUserName'"
                                       :title="$t('reportData.events.createdByUserName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdAt'"
                                       :title="$t('reportData.events.createdAt')"
                                       :width="200"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedByUserName'"
                                       :title="$t('reportData.events.updatedByUserName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedAt'"
                                       :title="$t('reportData.events.updatedAt')"
                                       :width="200"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventNote'"
                                       :title="$t('reportData.events.eventNote')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventDescription'"
                                       :title="$t('reportData.events.eventDescription')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventExpectedResults'"
                                       :title="$t('reportData.events.eventExpectedResults')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLearningGoals'"
                                       :title="$t('reportData.events.eventLearningGoals')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLabel'"
                                       :title="$t('reportData.events.eventLabel')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'archived'"
                                       :title="$t('reportData.events.archived')"
                                       :width="170"
                                       :template="archivedCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventMigrationId'"
                                       :title="$t('reportData.events.migrationEventId')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventStartDate'"
                                       :title="$t('reportData.events.migrationEventStartDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventStartDate'"
                                       :title="$t('reportData.events.migrationEventStartDateHour')"
                                       :width="150"
                                       :format="customTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventEndDate'"
                                       :title="$t('reportData.events.migrationEventEndDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventEndDate'"
                                       :title="$t('reportData.events.migrationEventEndDateHour')"
                                       :width="150"
                                       :format="customTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventDirectorate'"
                                       :title="$t('reportData.events.migrationEventDirectorate')"
                                       :width="300">
                    </kendo-grid-column>

                    <kendo-grid-column :field="'migrationEventActivityDirection'"
                                       :title="$t('reportData.events.migrationEventActivityDirection')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventLegalArea'"
                                       :title="$t('reportData.events.migrationEventLegalArea')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventFundingType'"
                                       :title="$t('reportData.events.migrationEventFundingType')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventProjectName'"
                                       :title="$t('reportData.events.migrationEventProjectName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventOrganizerName'"
                                       :title="$t('reportData.events.migrationEventOrganizerName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventSort'"
                                       :title="$t('reportData.events.migrationEventSort')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventName'"
                                       :title="$t('reportData.events.migrationEventName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationThematicArea'"
                                       :title="$t('reportData.events.migrationThematicArea')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationContactPersons'"
                                       :title="$t('reportData.events.migrationContactPersons')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventVenue'"
                                       :title="$t('reportData.events.migrationEventVenue')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventLocation'"
                                       :title="$t('reportData.events.migrationEventLocation')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationLecturers'"
                                       :title="$t('reportData.events.migrationLecturers')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationParticipantsMaxNum'"
                                       :title="$t('reportData.events.migrationParticipantsMaxNum')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventAudience'"
                                       :title="$t('reportData.events.migrationEventAudience')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationHotelName'"
                                       :title="$t('reportData.events.migrationHotelName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationHotelAddress'"
                                       :title="$t('reportData.events.migrationHotelAddress')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationLastDayForBooking'"
                                       :title="$t('reportData.events.migrationLastDayForBooking')"
                                       :width="200"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventStayFrom'"
                                       :title="$t('reportData.events.migrationEventStayFrom')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventStayTo'"
                                       :title="$t('reportData.events.migrationEventStayTo')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventDailyAllowanceFrom'"
                                       :title="$t('reportData.events.migrationEventDailyAllowanceFrom')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventDailyAllowanceTo'"
                                       :title="$t('reportData.events.migrationEventDailyAllowanceTo')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationNoteStatus'"
                                       :title="$t('reportData.events.migrationNoteStatus')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventSubscriptionStartDate'"
                                       :title="$t('reportData.events.migrationEventSubscriptionStartDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventSubscriptionEndDate'"
                                       :title="$t('reportData.events.migrationEventSubscriptionEndDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationExcludeFromReporting'"
                                       :title="$t('reportData.events.migrationExcludeFromReporting')"
                                       :width="200"
                                       :template="migrationExcludeCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventStatus'"
                                       :title="$t('reportData.events.migrationEventStatus')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationCreatedByUserName'"
                                       :title="$t('reportData.events.migrationCreatedByUserName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationCreatedAt'"
                                       :title="$t('reportData.events.migrationCreatedAt')"
                                       :width="200"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationUpdatedByUserName'"
                                       :title="$t('reportData.events.migrationUpdatedByUserName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationUpdatedAt'"
                                       :title="$t('reportData.events.migrationUpdatedAt')"
                                       :width="200"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationEventNote'"
                                       :title="$t('reportData.events.migrationEventNote')"
                                       :width="300">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>

        <DetailsModal v-model="detailsModel" :show="showDetails" @onClose="onDetailsClose"></DetailsModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import store from '../../store/store';
    import GridUserSettings from '../../components/grid/GridSettingsWrapper';
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import PageTitle from '../../components/common/PageTitle';
    import { RegisterFieldValueQueryFilter } from '../../models/enums';
    import DetailsModal from '../../components/dynamic/register/details.modal';
    import { mapGetters } from 'vuex'

    export default {
        created: function () {
            window.JSZip = JSZip // ���������� � �� �� ������ �������� � excel
        },
        props: {
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            }
        },
        components: {
            GridUserSettings,
            PageTitle,
            DetailsModal
        },
        data() {
            return {
                componentName: "eventsReportData",
                titleKey: 'reportData.events.title',
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true },
                    eventName: { name: 'eventName', type: 'string', editable: false, nullable: true, visible: true },
                    eventCode: { name: 'eventCode', type: 'string', editable: false, nullable: true, visible: true },
                    eventVenue: { name: 'eventVenue', type: 'string', editable: false, nullable: true, visible: true },
                    eventLocation: { name: 'eventLocation', type: 'string', editable: false, nullable: true, visible: true },
                    eventLocationDistrict: { name: 'eventLocationDistrict', type: 'string', editable: false, nullable: true, visible: true },
                    eventMainActivity: { name: 'eventMainActivity', type: 'string', editable: false, nullable: true, visible: true },
                    eventDirectorate: { name: 'eventDirectorate', type: 'string', editable: false, nullable: true, visible: true },
                    eventActivityDirection: { name: 'eventActivityDirection', type: 'string', editable: false, nullable: true, visible: true },
                    eventSort: { name: 'eventSort', type: 'string', editable: false, nullable: true, visible: true },
                    eventFundingType: { name: 'eventFundingType', type: 'string', editable: false, nullable: true, visible: true },
                    eventProjectName: { name: 'eventProjectName', type: 'string', editable: false, nullable: true, visible: true },
                    eventForm: { name: 'eventForm', type: 'string', editable: false, nullable: true, visible: true },
                    contactPersons: { name: 'contactPersons', type: 'string', editable: false, nullable: true, visible: true },
                    coordinators: { name: 'coordinators', type: 'string', editable: false, nullable: true, visible: true },
                    eventOrganizerName: { name: 'eventOrganizerName', type: 'string', editable: false, nullable: true, visible: true },
                    eventStartDate: { name: 'eventStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventEndDate: { name: 'eventEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventLegalArea: { name: 'eventLegalArea', type: 'string', editable: false, nullable: true, visible: true },
                    thematicArea: { name: 'thematicArea', type: 'string', editable: false, nullable: true, visible: true },
                    lecturers: { name: 'lecturers', type: 'string', editable: false, nullable: true, visible: true },
                    participantsMaxNum: { name: 'participantsMaxNum', type: 'number', editable: false, nullable: true, visible: true },
                    eventAudience: { name: 'eventAudience', type: 'string', editable: false, nullable: true, visible: true },
                    hotelName: { name: 'hotelName', type: 'string', editable: false, nullable: true, visible: true },
                    hotelAddress: { name: 'hotelAddress', type: 'string', editable: false, nullable: true, visible: true },
                    lastDayForBooking: { name: 'lastDayForBooking', type: 'date', editable: false, nullable: true, visible: true },
                    eventStayFrom: { name: 'eventStayFrom', type: 'date', editable: false, nullable: true, visible: true },
                    eventStayTo: { name: 'eventStayTo', type: 'date', editable: false, nullable: true, visible: true },
                    eventDailyAllowanceFrom: { name: 'eventDailyAllowanceFrom', type: 'date', editable: false, nullable: true, visible: true },
                    eventDailyAllowanceTo: { name: 'eventDailyAllowanceTo', type: 'date', editable: false, nullable: true, visible: true },
                    noteStatus: { name: 'noteStatus', type: 'string', editable: false, nullable: true, visible: true },
                    eventSubscriptionStartDate: { name: 'eventSubscriptionStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventSubscriptionEndDate: { name: 'eventSubscriptionEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    excludeFromReporting: { name: 'excludeFromReporting', type: 'boolean', editable: false, nullable: true, visible: true },
                    eventStatus: { name: 'eventStatus', type: 'string', editable: false, nullable: true, visible: true },
                    createdByUserName: { name: 'createdByUserName', type: 'string', editable: false, nullable: true, visible: true },
                    createdAt: { name: 'createdAt', type: 'date', editable: false, nullable: true, visible: true },
                    updatedByUserName: { name: 'updatedByUserName', type: 'string', editable: false, nullable: true, visible: true },
                    updatedAt: { name: 'updatedAt', type: 'date', editable: false, nullable: true, visible: true },
                    eventNote: { name: 'eventNote', type: 'string', editable: false, nullable: true, visible: true },
                    eventDescription: { name: 'eventDescription', type: 'string', editable: false, nullable: true, visible: true },
                    eventExpectedResults: { name: 'eventExpectedResults', type: 'string', editable: false, nullable: true, visible: true },
                    eventLearningGoals: { name: 'eventLearningGoals', type: 'string', editable: false, nullable: true, visible: true },
                    archived: { name: 'archived', type: 'boolean', editable: false, nullable: true, visible: true },
                    eventMigrationId: { name: 'eventMigrationId', type: 'number', editable: false, nullable: true, visible: true },
                    migrationEventStartDate: { name: 'migrationEventStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    migrationEventEndDate: { name: 'migrationEventEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    migrationEventDirectorate: { name: 'migrationEventDirectorate', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventActivityDirection: { name: 'migrationEventActivityDirection', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventLegalArea: { name: 'migrationEventLegalArea', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventFundingType: { name: 'migrationEventFundingType', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventProjectName: { name: 'migrationEventProjectName', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventOrganizerName: { name: 'migrationEventOrganizerName', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventSort: { name: 'migrationEventSort', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventName: { name: 'migrationEventName', type: 'string', editable: false, nullable: true, visible: true },
                    migrationThematicArea: { name: 'migrationThematicArea', type: 'string', editable: false, nullable: true, visible: true },
                    migrationContactPersons: { name: 'migrationContactPersons', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventVenue: { name: 'migrationEventVenue', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventLocation: { name: 'migrationEventLocation', type: 'string', editable: false, nullable: true, visible: true },
                    migrationLecturers: { name: 'migrationLecturers', type: 'string', editable: false, nullable: true, visible: true },
                    migrationParticipantsMaxNum: { name: 'migrationParticipantsMaxNum', type: 'number', editable: false, nullable: true, visible: true },
                    migrationEventAudience: { name: 'migrationEventAudience', type: 'string', editable: false, nullable: true, visible: true },
                    migrationHotelName: { name: 'migrationHotelName', type: 'string', editable: false, nullable: true, visible: true },
                    migrationHotelAddress: { name: 'migrationHotelAddress', type: 'string', editable: false, nullable: true, visible: true },
                    migrationLastDayForBooking: { name: 'migrationLastDayForBooking', type: 'date', editable: false, nullable: true, visible: true },
                    migrationEventStayFrom: { name: 'migrationEventStayFrom', type: 'date', editable: false, nullable: true, visible: true },
                    migrationEventStayTo: { name: 'migrationEventStayTo', type: 'date', editable: false, nullable: true, visible: true },
                    migrationEventDailyAllowanceFrom: { name: 'migrationEventDailyAllowanceFrom', type: 'date', editable: false, nullable: true, visible: true },
                    migrationEventDailyAllowanceTo: { name: 'migrationEventDailyAllowanceTo', type: 'date', editable: false, nullable: true, visible: true },
                    migrationNoteStatus: { name: 'migrationNoteStatus', type: 'string', editable: false, nullable: true, visible: true },
                    migrationEventSubscriptionStartDate: { name: 'migrationEventSubscriptionStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    migrationEventSubscriptionEndDate: { name: 'migrationEventSubscriptionEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    migrationExcludeFromReporting: { name: 'migrationExcludeFromReporting', type: 'boolean', editable: false, nullable: true, visible: true },
                    migrationEventStatus: { name: 'migrationEventStatus', type: 'string', editable: false, nullable: true, visible: true },
                    migrationCreatedByUserName: { name: 'migrationCreatedByUserName', type: 'string', editable: false, nullable: true, visible: true },
                    migrationCreatedAt: { name: 'migrationCreatedAt', type: 'date', editable: false, nullable: true, visible: true },
                    migrationUpdatedByUserName: { name: 'migrationUpdatedByUserName', type: 'string', editable: false, nullable: true, visible: true },
                    migrationUpdatedAt: { name: 'migrationUpdatedAt', type: 'date', editable: false, nullable: true, visible: true },
                    migrationEventNote: { name: 'migrationEventNote', type: 'string', editable: false, nullable: true, visible: true },
                    migrationExcludeCellTemplate: { name: 'migrationExcludeCellTemplate', type: 'boolean', editable: false, nullable: true, visible: true },
                    eventLabel: { name: 'eventLabel', type: 'string', editable: false, nullable: true, visible: true },
                    eventLabelEn: { name: 'eventLabelEn', type: 'string', editable: false, nullable: true, visible: true },
                },
                rawHtml: "",
                transportSettings: {
                    read: {
                        url: `${store.getters.baseUrl}/api/reportData/nipEvents`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel'],
                    excel: {
                        fileName: 'NIPEvents.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                },
                showReportDataEventsSettings: false,
                showReportDataEventsSettingsForm: false,
                searchQuery: '',
                detailsModel: null,
                showDetails: false,
            }
        },
        methods: {
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            detailsBtnClick(args) {
                this.showDetailsModal(args, RegisterFieldValueQueryFilter.All);
            },
            showDetailsModal(args, filter) {
                this.$api.dynamicRegister
                    .getDetails(args.id, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.detailsModel = model;
                            this.showDetails = true;
                        }
                    })
                    .catch(error => {
                        this.detailsModel = null;
                        this.showDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onDetailsClose() {
                this.showDetails = false;
                this.detailsModel = null;
            },
            excelExport(args) {
            },
            goToExportTemplate() {
            },
            selectImportFiles() {
            },
            goToImportFromExcel(args) {
            },
            dataBound(e) {
                if (e.sender.options.dataSourceRef === 'datasource1' && !this.showReportDataEventsSettings) {
                    this.showReportDataEventsSettings = true;
                }
            },
            parameterMap: function (options, operation) {
                options.convertFilterDatesToUTC = true;
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            saveState: function () {
                let grid = this.$refs.reportDataEventsGrid.kendoWidget();

                localStorage["events-reportdata-grid-options"] = kendo.stringify(grid.getOptions());
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            toolbarTemplate: function () {
                let templateHtml =
                    '<span>' +
                    '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
                    '</span>';

                return kendo.template(templateHtml);
            },
            excludeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.excludeFromReporting ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.excludeFromReporting ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            migrationExcludeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.migrationExcludeFromReporting ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.migrationExcludeFromReporting ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            archivedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.archived ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.archived ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            yesNoCellTemplate: function (dataItemField) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItemField ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItemField ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.reportDataEventsGrid,
                        btns: [{
                            name: "details",
                            text: "",
                            tooltip: this.$t('buttons.details.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.detailsBtnClick
                        },
                        ]
                    }
                };
            },
            changeGridSettings(gridName) {
                if (gridName === 'reportDataEventsGrid') {
                    this.showReportDataEventsSettingsForm = !this.showReportDataEventsSettingsForm;
                }
            },
            refresh() {
                this.$refs['reportDataEventsGrid'].kendoWidget().dataSource.read();
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.reportDataEventsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.reportDataEventsGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        mounted: function () {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            ...mapGetters(['timeFormat', 'dateFormat', 'dateTimeFormat']),
            customTimeFormat() {
                return `{0:${this.timeFormat}}`
            },
            customDateFormat() {
                return `{0:${this.dateFormat}}`
            },
            customDateTimeFormat() {
                return `{0:${this.dateTimeFormat}}`
            },
            token: function () {
                return store.getters.authToken;
            },
            hasEventReadRights() {
                return this.$store.getters.claims.event.read;
            }
        }
    }
</script>

<style scoped>
    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>

<style lang="scss">
    .grid-wrapper {
        overflow-x: auto;
    }

    tr.left-border-danger {
        &:hover

    {
        color: rgba(255, 0, 0, 0.7) !important;
    }

    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }

    }

    tr.left-border-blue {
        &:hover

    {
        color: #3498db !important;
    }

    td:first-child {
        border-left: 4px solid #3498db !important;
    }

    }

    tr.left-border-green {
        &:hover

    {
        color: #4caf50 !important;
    }

    td:first-child {
        border-left: 4px solid #4caf50 !important;
    }

    }

    tr.left-border-secondary {
        &:hover

    {
        color: #707a8a !important;
    }

    td:first-child {
        border-left: 4px solid #707a8a !important;
    }

    }

    .k-grid td {
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
